import { lazy, Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import Loader from '../../shared/ui/Loader'

// Pages
const StaffCalendarPage = lazy(
  () => import('../../pages/StaffPage/StaffCalendarPage'),
)
const StaffProfilePage = lazy(
  () => import('../../pages/StaffPage/StaffProfilePage'),
)
const StaffReviewsPage = lazy(
  () => import('../../pages/StaffPage/StaffReviewsPage'),
)

export const getStaffRoutes = () => [
  {
    path: 'staff',
    element: (
      <Suspense fallback={<Loader />}>
        <Outlet />
      </Suspense>
    ),
    children: [
      { path: 'my-calendar', element: <StaffCalendarPage />, index: true },
      {
        path: 'my-profile',
        element: <StaffProfilePage />,
      },
      {
        path: 'my-reviews',
        element: <StaffReviewsPage />,
      },
    ],
  },
]
